import Button from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  const handleExploreApps = () => {
    navigate('/reviews');
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-gray-900"
      style={{
        backgroundImage: `linear-gradient(rgba(17, 24, 39, 0.8), rgba(17, 24, 39, 0.9)), url('https://public.readdy.ai/ai/img_res/3c302b1afbd7ab269c00f54e10b6ab5c.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            EarnProof
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-cyan-400">
              Real Apps. Real Earnings.
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
            Schluss mit Fake-Versprechungen. Hier findest du nur geprüfte Apps, Games und Crypto-Tools mit echten Beweisen und ehrlichen Reviews.
          </p>

          {/* Earnings Proof */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20 mb-8">
            <p className="text-white/80 text-sm">Meine Einnahmen insgesamt</p>
            <p className="text-white text-2xl font-bold">€3.7k</p>
          </div>

          <div className="flex justify-center">
            <Button variant="primary" size="lg" className="text-lg" onClick={handleExploreApps}>
              <i className="ri-search-line mr-2"></i>
              Apps entdecken
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-teal-400"></i>
      </div>
    </section>
  );
}
